import uuidv4 from "uuid/v4";

export const generateUuid = () => {
  return uuidv4();
};
